import { FeatureFlagsMap, MmuAppContext, MmuMainMenuMainEntry, MmuUserRoles } from '@move/core';


export const serviceMenuItems = (appContext: string): MmuMainMenuMainEntry[] => {
  return [
    {
      label: 'mainMenu.serviceDashboard',
      link: '/dashboard',
      icon: 'wrench',
      isExternalLink: appContext !== MmuAppContext.CONTAINER
    },
    {
      label: 'mainMenu.customers',
      link: '/service/customers',
      icon: 'users',
      isExternalLink: appContext !== MmuAppContext.CONTAINER,
      children: [
        {
          label: 'mainMenu.customersOverview',
          link: '/service/customers',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          exactUrlMatch: 'exact'
        },
        {
          label: 'mainMenu.admin',
          link: '/user/admin/consents',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          exactUrlMatch: 'exact',
          roles: [MmuUserRoles.ADMIN]
        }
      ]
    },

    {
      label: 'mainMenu.devices',
      link: '/service/devices',
      icon: 'dryer',
      isExternalLink: appContext !== MmuAppContext.CONTAINER,
      children: [
        {
          label: 'mainMenu.deviceList',
          link: '/service/devices',
          exactUrlMatch: 'exact',
          isExternalLink: appContext !== MmuAppContext.CONTAINER
        },
        {
          label: 'mainMenu.devicePairing',
          link: '/appliances/pairing',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          roles: [MmuUserRoles.ADMIN, MmuUserRoles.ENGINEER]
        }
      ]
    },

    /**
     * @deprecated FFactionsNNG
     */
    {
      label: 'mainMenu.notifications',
      link: '/actions/notifications',
      icon: 'bell',
      feature: FeatureFlagsMap.FFActionsNNG,
      isExternalLink: appContext !== MmuAppContext.CONTAINER,
      children: [
        {
          label: 'mainMenu.notificationsOverview',
          link: '/actions/notifications',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          exactUrlMatch: 'exact'
        },
        {
          label: 'mainMenu.notificationsSettings',
          link: '/actions/notifications/settings',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          exactUrlMatch: 'exact'
        }
      ]
    },
    {
      label: 'mainMenu.serviceOrganisation',
      link: '/user/admin/organizations',
      icon: 'briefcase',
      isExternalLink: appContext !== MmuAppContext.CONTAINER,
      roles: [MmuUserRoles.ADMIN],
      children: [
        {
          label: 'mainMenu.companyManagement',
          link: '/user/admin/organizations',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          exactUrlMatch: 'exact'
        },
        {
          label: 'mainMenu.userManagement',
          link: '/user/admin/users',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          exactUrlMatch: 'exact'
        }
      ]
    }
  ];
};
